<div *ngIf="(this.mls.featureOnOffList.moduleList.CONNECTION.value || !mls.userLoginFlow)">
<!--Loaders-->
    <div *ngIf="!finished &&  Connoffset ==0 && masterService.isOnline==true && connSuggLoader === false">
        <div *ngIf="!finished" class='text-center'>
            <img src="assets/themes/images/img-video-loader.gif" width="40" id="loadmore_post">
        </div>
    </div><br *ngIf="!finished &&  Connoffset ==0 && connSuggLoader === false">
    <!--EOf Loaders-->

    <!-- empty list div start -->
    <div *ngIf="(total_connection_request==0 || len==0) && location!='survey' " class="mt-3">
        <div class="p-3 text-center">
            <img class="mb-3" src="assets/themes/icons/no-connection.svg" alt="no data found">
            <h6 class="mb-1 heading-4"><span class="color-grey-500">{{mls.languageText.connection_request_list.key1}}</span><span
                    *ngIf="mls?.is_lskey_display==1">(connection_request_list.key1)</span></h6>
            <p class="mb-1 secondary-paragraph"><span class="color-grey-500">{{mls.languageText.connection_request_list.key2}}</span><span
                    *ngIf="mls?.is_lskey_display==1">(connection_request_list.key2)</span></p>
        </div>
    </div>
    <br *ngIf="total_connection_request==0 || len==0">
    <!-- empty list div end -->

    <!-- connection request -->


    <!-- grand round card start-->

    <div *ngIf="total_connection_request >=0 && (location!='gr' && location!='survey') && location!='clinical'"
        class="mt-3">
        <div class="mb-3" *ngIf="total_connection_request>=0">
            <div class="row">
                <div class="col-12">
                    <p class="d-flex align-items-center" ><span class="heading-4">
                        <span class="color-grey-700">{{request_header?.header}}</span></span>
                        <span class="req-sent-chip-wrapper">
                        <span *ngIf="total_connection_request !=0"
                            class="ml-3 chip small error filled">{{total_connection_request}}</span></span>
                        <span *ngIf="(limit!=undefined && this.total_connection_request >limit)"
                            (click)="navigateTo('connection/request')" class=" cursor-pointer float-right button">
                            <!-- {{multiLangService.View_All_Requests}} -->
                            <span class="mr-2">View All</span>
                            <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.229699 0.814415C0.424961 0.619153 0.741543 0.619153 0.936805 0.814415L5.77014 5.64775C5.9654 5.84301 5.9654 6.15959 5.77014 6.35486L0.936805 11.1882C0.741543 11.3835 0.424961 11.3835 0.229699 11.1882C0.0344364 10.9929 0.0344364 10.6763 0.229699 10.4811L4.70948 6.0013L0.229699 1.52152C0.0344364 1.32626 0.0344364 1.00968 0.229699 0.814415Z" fill="#1D1919"/>
                                </svg>
                        </span>
                    </p>
                </div>
            </div>
        </div>
        <div>
            <!-- connection list -->
            <!-- item -->
            <div class="px-3 py-3 connection-card mb-3"
                *ngFor="let suggObj of connectionRequestData | slice:0:limit; let index=index">
                <div>

                    <app-connection-card [usercardsize]="'s'" [suggObj]="suggObj" [callingfrom]="screenName" [index]="index"
                        (resetSuggList)=resetSuggList($event)
                        (removeconcard)=removeconcard($event)></app-connection-card>
                </div>
            </div>
            <!-- <div class="text-center text-success pt-2 pb-2 fnt-size14px fnt-weight500" ></div> -->


            <div *ngIf="(!finished && Connoffset!=1 && masterService.isOnline==true && connSuggLoader === false)"
                class='text-center'>
                <img class="text-center" src="assets/themes/images/img-video-loader.gif" width="40"
                    id="loadmore_post">
            </div>

            <div *ngIf="(finished && Connoffset!=0 && (limit==undefined || this.total_connection_request <limit))"
                class="text-center py-2 cursor-pointer button"
                (click)="sentRequestviewmore()">
                <span class="mr-2">{{request_header.view_more_text}}</span>
                <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.229699 0.814415C0.424961 0.619153 0.741543 0.619153 0.936805 0.814415L5.77014 5.64775C5.9654 5.84301 5.9654 6.15959 5.77014 6.35486L0.936805 11.1882C0.741543 11.3835 0.424961 11.3835 0.229699 11.1882C0.0344364 10.9929 0.0344364 10.6763 0.229699 10.4811L4.70948 6.0013L0.229699 1.52152C0.0344364 1.32626 0.0344364 1.00968 0.229699 0.814415Z" fill="#1D1919"/>
                    </svg>
              </div>

            <!-- end connection list -->
        </div>
    </div>
    <!-- grand round card end -->





    <div *ngIf="(total_connection_request >0 && location=='gr' && location!='clinical')"
        class="mt-3">
        <div *ngIf="total_connection_request>0">
            <div class="row">
                <div class="col-12 ">
                    <p class="px-4 d-flex align-items-center justify-content-between">
                        <span>
                            <span class="heading-4">
                                <span class="color-grey-700">{{request_header?.header}}</span>
                            </span>
                            <span class="ml-1 chip small filled error">{{total_connection_request}}</span>
                        </span>
                        <span>
                        <div *ngIf="(limit!=undefined && this.total_connection_request >limit)"
                            (click)="navigateTo('connection/request')" class=" cursor-pointer float-right button d-flex">
                            <span>{{mls.languageText.connection_request_list.key3}}</span> 
                            <span
                                *ngIf="mls?.is_lskey_display==1">(connection_request_list.key3)</span>
                                <img src="assets/themes/icons/Vector.svg" alt="">
                            </div>
                        </span>
                    </p>
                </div>
            </div>
        </div>
        <div >
            <!-- connection list -->
            <!-- item -->
            <div class="list-wrappers">
            <div class="px-3 py-3 card-bottom-border"
                *ngFor="let suggObj of connectionRequestData | slice:0:limit; let index=index">
                <div>

                    <app-connection-card [usercardsize]="'s'" [callingfrom]="callingfrom" [suggObj]="suggObj"
                        [index]="index" (resetSuggList)=resetSuggList($event)
                        (removeconcard)=removeconcard($event)></app-connection-card>
                </div>
            </div>
            </div>

            <div *ngIf="!finished && Connoffset!=1 && masterService.isOnline==true && connSuggLoader === false"
                class='text-center'>
                <img class="text-center" src="assets/themes/images/img-video-loader.gif" width="40"
                    id="loadmore_post">
            </div>

            <div *ngIf="(finished && Connoffset!=0 && (limit==undefined || this.total_connection_request <limit))"
                class="text-center pt-2 pb-2 cursor-pointer button"
                (click)="sentRequestviewmore()">{{request_header.view_more_text}} </div>

            <!-- end connection list -->
        </div>
    </div>

    <!-- survey card start -->
    <div *ngIf="location=='survey' && location!='clinical'"
        class="survey-connection-card">
        <div class="mb-2" *ngIf="total_connection_request>0">
            <div class="row">
                <div class="col-12">
                    <p class="px-4 pt-4 d-flex align-items-center justify-content-between" ><span class="heading-4">
                        <span class="color-grey-700">{{request_header?.header}}</span></span>
                        <span *ngIf="(limit!=undefined && this.total_connection_request >limit)"
                            (click)="navigateTo('connection/request')" class=" cursor-pointer float-right button">
                            <span class="mr-2">View All</span>
                            <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.229699 0.814415C0.424961 0.619153 0.741543 0.619153 0.936805 0.814415L5.77014 5.64775C5.9654 5.84301 5.9654 6.15959 5.77014 6.35486L0.936805 11.1882C0.741543 11.3835 0.424961 11.3835 0.229699 11.1882C0.0344364 10.9929 0.0344364 10.6763 0.229699 10.4811L4.70948 6.0013L0.229699 1.52152C0.0344364 1.32626 0.0344364 1.00968 0.229699 0.814415Z" fill="#1D1919"/>
                                </svg>
                        </span>
                    </p>
                </div>
            </div>
        </div>
        <div *ngIf="(total_connection_request==0 || len==0)" class="mt-3">
            <div class="p-3 text-center">
                <img class="mb-3" src="assets/themes/icons/no-connection.svg" alt="no data found"/>
                <h6 class="mb-1 heading-4"><span class="color-grey-500">{{mls.languageText.connection_request_list.key1}}</span><span
                        *ngIf="mls?.is_lskey_display==1">(connection_request_list.key1)</span></h6>
                <p class="mb-1"><span class="color-grey-500">{{mls.languageText.connection_request_list.key2}}</span><span
                        *ngIf="mls?.is_lskey_display==1">(connection_request_list.key2)</span></p>
            </div>
        </div>

        <div>
            <!-- connection list -->
            <!-- item -->
            <div class="list-wrappers">
            <div class="px-4 py-3 card-bottom-border"
                *ngFor="let suggObj of connectionRequestData | slice:0:limit; let index=index">
                <div>

                    <app-connection-card [usercardsize]="'s'" [suggObj]="suggObj" [index]="index"
                        (resetSuggList)=resetSuggList($event)
                        (removeconcard)=removeconcard($event)></app-connection-card>
                </div>
            </div>
            </div>
            <div *ngIf="(!finished && Connoffset!=1 && masterService.isOnline==true && connSuggLoader === false)"
                class='text-center'>
                <img class="text-center" src="assets/themes/images/img-video-loader.gif" width="40"
                    id="loadmore_post">
            </div>

            <div *ngIf="(finished && Connoffset!=0 && (limit==undefined || this.total_connection_request <limit))"
                class="text-center py-2 cursor-pointer button"
                (click)="sentRequestviewmore()">
                <span class="mr-2">{{request_header.view_more_text}}</span>
                <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.229699 0.814415C0.424961 0.619153 0.741543 0.619153 0.936805 0.814415L5.77014 5.64775C5.9654 5.84301 5.9654 6.15959 5.77014 6.35486L0.936805 11.1882C0.741543 11.3835 0.424961 11.3835 0.229699 11.1882C0.0344364 10.9929 0.0344364 10.6763 0.229699 10.4811L4.70948 6.0013L0.229699 1.52152C0.0344364 1.32626 0.0344364 1.00968 0.229699 0.814415Z" fill="#1D1919"/>
                    </svg>
            </div>
        </div>
    </div>
    <!-- survey card ended -->

    <div *ngIf="(suggestionLength>=1 && limit==undefined)" class="mt-3">
        <div>
            <div class="row">
                <div class="col-12">
                    <p class="d-flex"><span class="heading-4">{{mls.languageText.connection_request_list.key4}}</span>
                        <span
                            *ngIf="mls?.is_lskey_display==1">(connection_request_list.key4)
                        </span>
                    </p>
                </div>
            </div>
        </div>

        <app-connection-sugg-filter [suggestionFilter]="suggestionFilter" [filterIndex]="filterIndex"
            (connectionFilter)="applySuggestionFilter($event)"></app-connection-sugg-filter>

        <div id="timelineView" infiniteScroll [infiniteScrollDistance]="numbers.TWO"
            [infiniteScrollThrottle]="numbers.FIFTY" [infiniteScrollDisabled]="busyGettingData" (scrolled)="onScrollDown()" [scrollWindow]="true">
            <!-- suggestion  list -->
            <!-- suggestion card -->
            <div *ngFor="let suggObj of suggestionData; let index=index" class="connection-card px-3 py-3 mb-3">
                <app-connection-card [usercardsize]="'m'" [callingfrom]="'connection request list'"
                    [suggObj]="suggObj"></app-connection-card>
            </div>

            <div *ngIf="(finishedsugg && suggestionData.length === 0)" class="text-center p-5">
                <img src="./assets/images/suggnodata.png">
                <h6 class="pt-3">{{mls.languageText.connection_request_list.key5}}</h6>
                <p class="p-2">{{mls.languageText.connection_request_list.key6}}</p>
            </div>

            <div *ngIf="!finishedsug && offset!=0 && masterService.isOnline==true " class='text-center'>
                <img src="assets/themes/images/img-video-loader.gif" width="40" id="loadmore_post">
            </div>
            <!-- suggestion card -->
        </div>
    </div>

    <!--Loaders-->
    <div *ngIf="!finishedsugg  && limit==undefined && offset==1 && masterService.isOnline==true && connSuggLoader === false">
        <div *ngIf="!finishedsugg && limit==undefined && masterService.isOnline==true " class='text-center'>
            <img src="assets/themes/images/img-video-loader.gif" width="40" id="loadmore_post">
        </div>
    </div>
    <!-- <br *ngIf="!finished"> -->
    <!--EOf Loaders-->

    <!-- end connection request -->

    <app-info-modal (resetInfoModal)=resetInfoModal() [isInfoModalShown]=isInfoModalShown
        [info_msg]=info_msg></app-info-modal>

    </div>